export default "__VITE_ASSET__Bg17aITt__"